import { createContext } from 'react';

import { Customer } from 'types';

export type CustomerContextType = {
  loadCustomer: (customer: Customer) => void;
} & Customer;

export default createContext<CustomerContextType>({} as CustomerContextType);
